import { FilterCollapse } from 'libs/searchspring/components/collection/filters/FilterCollapse'
import clsx from 'clsx'
import { ColorSwatch, IconImage } from 'libs/searchspring/components/collection/filters/FilterCustomisations'
import { FilterInputSlider } from 'libs/searchspring/components/collection/filters/FilterSlider'
import { useFetchedFilter, useFilterCustomizations, useFilterValues, useActiveFilterLabel } from 'libs/searchspring/components/collection/filters/filterHooks'

export function FilterItem({ filter, activeFilters, fetchedFilters, onFilter }) {
  if (!filter) return null

  const fetchedFilter = useFetchedFilter(filter, fetchedFilters)
  const filterCustomizations = useFilterCustomizations(filter.field)
  const values = useFilterValues(filter, activeFilters, fetchedFilter, filterCustomizations)
  const activeFilterLabel = useActiveFilterLabel(filter, values, fetchedFilter)

  // Render appropriate filter content based on type
  const FilterContent = () => {
    switch (filter.type) {
      case 'slider':
        return <FilterInputSlider filter={filter} fetchedFilter={fetchedFilter} onFilter={onFilter} />
      case 'list':
        if (!values.length) return null
        return <FilterInputs field={filter.field} values={values} onFilter={onFilter} />
      default:
        if (!values.length) return null
        return <FilterInputs field={filter.field} values={values} onFilter={onFilter} />
    }
  }

  return (
    <FilterCollapse label={filter.label} activeFilterLabel={activeFilterLabel}>
      <div className="flex flex-wrap gap-2 pt-2 pb-6">
        {FilterContent()}
      </div>
    </FilterCollapse>
  )
}

const FilterInputs = ({ values, onFilter, field }) => {
  return (
    <>
    {values.map((item) => {
      return (
        <div className="flex items-center" key={item.value}>
          <input
            id={item.value}
            type="checkbox"
            name={field}
            checked={item.checked}
            disabled={item.disabled}
            onClick={() => onFilter(item.value)}
            className="hidden field-checkbox peer"
          />
          <label
            for={item.value}
            className={clsx('flex items-center gap-2 paragraph-md peer-disabled:text-neutral-medium btn btn-primary-outline peer-checked:btn-primary btn-lg !border-neutral-tertiary hover:!border-brand-black', item.icon && 'flex-col')}
          >
            {item.color && <ColorSwatch color={item.color} />}
            {item.icon && <IconImage iconObject={item.icon} />}
            <div className={'inline-block'}>
            {item.label}
            {!item.count ? null : (
              <span className="paragraph-md text-neutral-secondary">
                &nbsp;({item.count})
              </span>
            )}
            </div>
          </label>
        </div>
      )
    })}
    </>
  )
}
